import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter, IonTextarea, useIonRouter, IonLoading } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

import { useHistory} from "react-router-dom";

function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}


function setFunction_tutorial(event) {


    alert("in SET FUNCTION TUTORIAL");
    alert(event);

    Preferences.set({
        key: 'selected_tutorial',
        //value: event,
        value: JSON.stringify({
            tutorial_id: event[0],
            tutorial_name: event[1],
            details: event[2],
            status: event[3],
            dateCreated: event[4],
            lastModified: event[5],
        })

    })

}

export function CreateInventoryProductModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [selectedFile, setSelectedFile] = useState(null);


    let [productID, setProductID] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [productImageNumber, setProductImageNumber] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [isloading, setLoading] = useState(false);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);



    // let createProductAddition_type = useRef(props.data.addition_type);
    // let createProductTypeRef = useRef(props.data.itemType);
    // let createProductDescriptionRef = useRef(props.data.itemDescription);
    // let createProductPartNumRef = useRef(props.data.vendorPartNum);
    // let createProductPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createProductAddressRef = useRef(props.data.vendorAddress);
    // let createProductCityRef = useRef(props.data.vendorCity);
    // let createProductCountryRef = useRef(props.data.vendorCountry);
    // let createProductCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createProductSalePriceRef = useRef(props.data.salePrice);
    // let createProductQtyInUse = useRef(props.data.qtyInUse);
    // let createProductDateCreated = useRef(props.data.dateCreated);
    // let createProductAddedBy = useRef(props.data.addedBy);


    let [createProductAddition_type, setCreateProductAddition_type] = useState(props.data.addition_type);

    let [storefront, setStoreFront] = useState(props.data.storefront);

    let [itemID, setItemID] = useState(props.data.itemID);
    let [createProductType, setCreateProductType] = useState(props.data.itemType);
    let [createProductName, setProductName] = useState(props.data.itemName);
    let [createProductDescription, setCreateProductDescription] = useState(props.data.itemDescription);
    let [createProductPartNum, setCreateProductPartNum] = useState(props.data.vendorPartNum);
    let [createProductPhoneNumber, setCreateProductPhoneNumber] = useState(props.data.vendorPhoneNumber);
    let [createProductAddress, setCreateProductAddress] = useState(props.data.vendorAddress);
    let [createProductCity, setCreateProductCity] = useState(props.data.vendorCity);
    let [createProductCountry, setCreateProductCountry] = useState(props.data.vendorCountry);
    let [createProductCostPerUnit, setCreateProductCostPerUnit] = useState(props.data.costPerUnit);
    let [createProductSalePrice, setCreateProductSalePrice] = useState(props.data.salePrice);
    let [createProductQtyInUse, setCreateProductQtyInUse] = useState(props.data.qtyInUse);
    let [createProductDateCreated, setCreateProductDateCreated] = useState(props.data.dateCreated);
    let [createProductAddedBy, setCreateProductAddedBy] = useState(props.data.addedBy); 
    let [createQtyUnits, setQtyUnits] = useState(props.data.qtyUnits);

    let history = useHistory();
    let router = useIonRouter();

    function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        setProductImageNumber("1");
        setProductPic1(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setProductImageNumber("2");
        setProductPic2(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setProductImageNumber("3");
        setProductPic3(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setProductImageNumber("4");
        setProductPic4(event);
        setTakePhotoStatus4(false);
    }


    function handle_no_attachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            //setProductImageNumber(event[0]);
            setProductPic1(noImageFile);
            setProductPic2(noImageFile);
            setProductPic3(noImageFile);
            setProductPic4(noImageFile);

            //alert("No Product Pics Option checked");

        })
    }


    function createProduct(e)
    {
        
        e.preventDefault();
        setLoading(true);
        //alert("In Crate Product Function");
       //alert(schema);
       //alert(createProductPartNum);
       //alert(createProductPhoneNumber);
       //alert(createProductCostPerUnit);
       // alert(pic4.value);
       //alert(totalProductPics);

       if (productPic1 == null) {
        alert("Image 1 is required.");

        setLoading(false);

        return;
      }

        
        let formData = new FormData();
        //formData.append('xProductPics', totalProductPics);
        //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
        formData.append('Tracker', '74300_retail');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryProductType', createProductType);
        formData.append('xInventoryProductName', createProductName);
        formData.append('xInventoryProductDescription', createProductDescription);
        formData.append('xInventoryProductPartNum', createProductPartNum);
        formData.append('xInventoryProductPhoneNumber', createProductPhoneNumber);
        formData.append('xInventoryProductAddress', createProductAddress);
        formData.append('xInventoryProductCity', createProductCity);
        formData.append('xInventoryProductCountry', createProductCountry);
        formData.append('xInventoryProductCostPerUnit', createProductCostPerUnit);
        formData.append('xInventoryProductSalePrice', createProductSalePrice);
        formData.append('xProductQtyInUse', createProductQtyInUse);
        formData.append('xSupportingDocumentation', selectedFile);
        //formData.append('xEnterAdminPassword', adminPassword);
        formData.append('xStorefront', storefront);
        formData.append('sessionID', sessionID);
        formData.append('xPic1', productPic1);
        formData.append('xPic2', productPic2);
        formData.append('xPic3', productPic3);
        formData.append('xPic4', productPic4);
        formData.append('xProductQtyUnits', createQtyUnits);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


            let rows = data.toString().split('~~~');
            let cols = rows[0].split('|');

            //alert(authenticatedMerchent_context.initialSetup?.details?.step_3);
            //alert('PRODUCT_CREATED');
    
            if(authenticatedMerchent_context.initialSetup?.details?.step_3 == false && cols[1].trim() === 'PRODUCT_CREATED')
            {
                alert("INITIAL SETUP PRODUCT CREATED");
                updateInitialSetup({step_1: true, step_2: true, step_3: true, step_4: authenticatedMerchent_context.initialSetup?.details?.step_4});
                window.location.href = '/retail_merchantMainPageApp';
            }
            else if(
                ((authenticatedMerchent_context.selectedTutorial?.tutorial_id == '2' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) ||
                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '3' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)) && cols[1].trim() === 'PRODUCT_CREATED')
            {
                alert("TUTORIAL PRODUCT CREATED");
                updateSelectedTutorial({step_1: true, step_2: true});
                window.location.href = '/retail_merchantMainPageApp';
            }
            else
            {
                alert("PRODUCT CREATED");
                window.location.href = '/retail_merchantMainPageApp';
            }

            setLoading(false);
        })
        .catch(error => {
            console.error(error);
        })
    }


    function updateInitialSetup(event) {

        alert("in updateInitialSetup");
        alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '74003B_update_initialSetup');
         formData.append('user', acctID);
         formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
         formData.append('xInitialSetup_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines3 = rows[0].split('|');
            
             setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);

             let initialSetupParsed = {};
                
             try {
             initialSetupParsed = JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })
                 ? JSON.parse(JSON.stringify({
                     setup_id: lines3[0],
                     details: lines3[1],
                     status: lines3[2],
                     dateCreated: lines3[3],
                     lastModified: lines3[4],
                 })) : {};

             if (typeof initialSetupParsed.details === 'string') {
                 initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
             }
             } catch (e) {
             console.warn('Error parsing initialSetup:', e);
             initialSetupParsed = {};
             }


          authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 

             alert("UPDATE COMPLETE");

             history.push('/retail_merchantMainPageApp');
         })
     }

     function updateSelectedTutorial(event) {

        alert("in updateSelectedTutorial");
        alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '33_update_selectedTutorial');
         formData.append('user', acctID);
         formData.append('xTutorial_id', authenticatedMerchent_context.selectedTutorial?.tutorial_id);
         formData.append('xTutorial_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            alert("After UPDATING - Tutorial")
            alert(res);

            let rows = res.toString().split('~~~');

            let rowLength = rows.length;

            let cols = rows[0].split('|');


            setFunction_tutorial([event[0], event[1], cols[0], cols[1], event[4], event[5]]);

            let selectedTutorialParsed = {};

            try {
            selectedTutorialParsed = JSON.stringify({
                setup_id: event[0],
                name: event[1],
                details: cols[0],
                status: cols[1],
                dateCreated: event[4],
                lastModified: event[5],
            })
                ? JSON.parse(JSON.stringify({
                    setup_id: event[0],
                    namne: event[1],
                    details: cols[0],
                    status: cols[1],
                    dateCreated: event[4],
                    lastModified: event[5],
                })) : {};

            if (typeof selectedTutorialParsed.details === 'string') {
                selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing selectedTutorial:', e);
            selectedTutorialParsed = {};
            }


         authenticatedMerchent_context.changeSelectedTutorial(selectedTutorialParsed); 


             alert("UPDATE COMPLETE");

             history.push('/retail_merchantMainPageApp');
            //props.closeModal(false);
         })
     }
     

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFile = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveProductPictures(event) { 

        setProductPic1(event.target.files[0]);
        setProductPic2(event.target.files[1]);
        setProductPic3(event.target.files[2]);
        setProductPic4(event.target.files[3]);
    
    
    }


    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setProductImageNumber(event.target.dataset.id);
            setProductPic1(file);
        }
        if(event.target.dataset.id == "2")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setProductImageNumber(event.target.dataset.id);
            setProductPic2(file);
        }
        if(event.target.dataset.id == "3")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setProductImageNumber(event.target.dataset.id);
            setProductPic3(file);
        }
        if(event.target.dataset.id == "4")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setProductImageNumber(event.target.dataset.id);
            setProductPic4(file);
        }
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createProduct(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    // useEffect(() => {

    //     setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg");
    //     handle_no_attachement();

    // }, [])
    
    //alert("IN CREATE PRODUCT")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={createProduct}>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonText className='professional-text'>CREATE PRODUCT</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
             <IonContent className='grid_content'>
            <IonSlides pager='true'>
                <IonSlide>
                <div style={{ height: '100%', overflowY: 'auto' }}>
                 <IonGrid>
                    <IonRow className='flash-tutorial'>
                                <IonCol size='12'>
                                    {(authenticatedMerchent_context.initialSetup?.details?.step_3 == false ||
                                        (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '2' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) ||
                                        (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '3' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false))
                                    ? <IonLabel className='flash-tutorial' for="ProductType">StoreFront</IonLabel>
                                    : <IonLabel for="ProductType">StoreFront</IonLabel>}
                                </IonCol>
                                <IonCol size='12'>
                                <select
                                    name="productType"
                                    id="productType"
                                    onChange={(e) => setStoreFront(e.target.value)}
                                >
                                    <option value="online" selected>Online</option>
                                    <option value="onsite">On-site</option>
                                </select>
                                </IonCol>
                            </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                        <   IonLabel>Product Name:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductName}
                            placeholder="Enter Product Name"
                            onIonChange={(e) => setProductName(e.target.value)}
                            required
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow size='12'>
                        <IonCol>
                        <IonLabel>Product Description:</IonLabel>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonTextarea className='professional-input' cols="40" rows="10"  placeholder="Enter Product Description" onIonChange={(e) => setCreateProductDescription(e.target.value)} required></IonTextarea>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Part Number:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductPartNum}
                            placeholder="Enter Product Part Number"
                            onIonChange={(e) => setCreateProductPartNum(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Phone Number:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductPhoneNumber}
                            placeholder="Enter Product Phone Number"
                            onIonChange={(e) => setCreateProductPhoneNumber(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                        <   IonLabel>Product Address:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductAddress}
                            placeholder="Enter Product Address"
                            onIonChange={(e) => setCreateProductAddress(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Product City:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductCity}
                            placeholder="Enter Product City"
                            onIonChange={(e) => setCreateProductCity(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Product Country:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductCountry}
                            placeholder="Enter Product Country"
                            onIonChange={(e) => setCreateProductCountry(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Product Cost:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductCostPerUnit}
                            type='number' 
                            step='any'
                            placeholder="Enter Product Cost Per Unit"
                            onIonChange={(e) => setCreateProductCostPerUnit(e.target.value)}
                            required
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Product Sale Price:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductSalePrice}
                            type='number' 
                            step='any'
                            placeholder="Enter Product Sale Price"
                            onIonChange={(e) => setCreateProductSalePrice(e.target.value)}
                            required
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Quantity Available:</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonInput className='professional-input'
                            value={createProductQtyInUse}
                            type='number'
                            placeholder="Enter Quantity Available"
                            onIonChange={(e) => setCreateProductQtyInUse(e.target.value)}
                            required
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonLabel for="qtyUnitsRef">Qty Units </IonLabel>
                            {/*<select name="employeeRole" id='employeeRole' ref={(e) => handleCreateEmployeeCompanyRole(e) }>*/}
                            <select name="qtyUnitsRef" id='qtyUnitsRef' value={createQtyUnits} onChange={(e) => setQtyUnits(e.target.value)}>
                                <option value='ea' selected>Quantity</option>
                                <option value='g'>grams</option>
                                <option value='kg'>Kilograms</option>
                                <option value='L'>Liters</option>
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> Image 1 </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonImg src={props.data.roomPic1}></IonImg>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='5'>                            
                            <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                            {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                        </IonCol>
                        <IonCol size='1'> 
                            <IonLabel>OR</IonLabel>
                        </IonCol>
                        <IonCol size='5'>
                            <input className='professional-input'
                                type="file"
                                accept="image/jpeg"
                                data-id='1'
                                onChange={handleFileChange}
                            />
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> Image 2 </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonImg src={props.data.roomPic2}></IonImg>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='5'>                            
                            <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                            {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                        </IonCol>
                        <IonCol size='1'> 
                            <IonLabel>OR</IonLabel>
                        </IonCol>
                        <IonCol size='5'>
                            <input className='professional-input'
                                type="file"
                                accept="image/jpeg"
                                data-id='2'
                                onChange={handleFileChange}
                            />
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel>Image 3</IonLabel>
                        </IonCol>
                    </IonRow>
                    <IonRow size='12'>
                        <IonCol>
                            <IonImg src={props.data.roomPic3}></IonImg>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='5'>                            
                            <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                            {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                        </IonCol>
                        <IonCol size='1'> 
                            <IonLabel>OR</IonLabel>
                        </IonCol>
                        <IonCol size='5'>
                            <input className='professional-input'
                                type="file"
                                accept="image/jpeg"
                                data-id='3'
                                onChange={handleFileChange}
                            />
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'> 
                            <IonLabel>Image 4</IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonImg src={props.data.roomPic4}></IonImg>
                        </IonCol>
                        <IonCol size='5'>
                            <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                            {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                        </IonCol>
                        <IonCol size='1'> 
                            <IonLabel>OR</IonLabel>
                        </IonCol>
                        <IonCol size='5'>
                            <input className='professional-input'
                                type="file"
                                accept="image/jpeg"
                                data-id='4'
                                onChange={handleFileChange}
                            />
                        </IonCol>
                    </IonRow>
                </IonGrid>
                </div>
                </IonSlide>
            </IonSlides>

            {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                
            {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}
        </IonContent>
        <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="6">
                           {(authenticatedMerchent_context.initialSetup?.details?.step_3 == false ||
                            (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '2' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) ||
                            (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '3' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false))
                           ? <IonButton type='submit' className='flash-tutorial'> Confirm </IonButton>
                           :<IonButton type='submit'> Confirm </IonButton>}
                        </IonCol>
                        <IonCol size="6">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </form>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}